export default {
  /** 成品进出存-获取分页查询列表 */
  LIST_INANDOUTSTORE_BY_PAGE: '/produce/pdProductInoutbound/queryPage',
  /** 成品进出存-批量导入 */
  LIST_INANDOUTSTORE_IMPORT: '/produce/pdProductInoutbound/importExcel',
  /** 成品进出存-批量导出 */
  LIST_INANDOUTSTORE_EXPORT: '/produce/pdProductInoutbound/exportExcel',
};
